if (!customElements.get('fbt-component')) {
  const BaseComponent = window.BundleComponent || customElements.get('bundle-component') || HTMLElement;

  class FbtComponent extends BaseComponent {
    setEvents() {
      super.setEvents();

      this.items.forEach(item => {
        if (item.dataset.fbtOptionsBound === '1') return;
        item.dataset.fbtOptionsBound = '1';

        const variantSelect = item.querySelector('.fbt-variant-select');
        const selectors = Array.from(item.querySelectorAll('.fbt-option-select'));
        const variants = Array.from(variantSelect.options).map(option => ({
          element: option,
          values: JSON.parse(option.dataset.options || '[]')
        }));

        const resolveVariant = () => {
          const values = selectors.map(select => select.value);
          const match = variants.find(variant =>
            variant.values.length === values.length &&
            variant.values.every((value, index) => value === values[index])
          );
          variantSelect.value = match ? match.element.value : '';
          this.handleVariantChange(item, variantSelect);

          // Keep every value selectable so shoppers can reach combinations that
          // require changing more than one option. Invalid combinations cannot be added.
          selectors.forEach((select, index) => {
            Array.from(select.options).forEach(option => {
              const candidate = variants.find(variant =>
                variant.values.every((value, position) =>
                  value === (position === index ? option.value : values[position])
                )
              );
              let suffix = '';
              if (!candidate) suffix = ' — Unavailable';
              else if (candidate.element.disabled) suffix = ' — Sold out';
              else if (candidate.element.dataset.preorder === 'true') suffix = ' — Pre-Order';
              option.textContent = option.value + suffix;
            });
          });
        };

        selectors.forEach(select => select.addEventListener('change', resolveVariant));
        if (selectors.length) resolveVariant();
        else this.handleVariantChange(item, variantSelect);
      });
    }

    handleVariantChange(item, select) {
      const selected = select.options[select.selectedIndex];
      if (selected) {
        item.dataset.defaultPrice = selected.dataset.price;
        item.dataset.comparePrice = selected.dataset.comparePrice || '0';
      }
      super.handleVariantChange(item, select);
    }

    updatePreorderBadge(item, select) {
      const selected = select.options[select.selectedIndex];
      const isPreorder = selected && !selected.disabled && selected.dataset.preorder === 'true';
      const badge = item.querySelector('.label.preorder');
      if (badge) badge.hidden = !isPreorder;

      const status = item.querySelector('[data-fbt-availability]');
      if (status) {
        status.textContent = !selected ? 'Unavailable combination' :
          selected.disabled ? 'Sold out' : isPreorder ? 'Pre-Order' : '';
        status.hidden = !status.textContent;
      }
    }

    handleSubmit(event) {
      if (event) event.preventDefault();
      if (this.isSubmitting) return;
      this.updateTotal();
      if (!this.submitButton || this.submitButton.disabled) return;

      const items = this.items.filter(item => item.classList.contains('checked')).map(item => {
        const select = item.querySelector('.fbt-variant-select');
        const selected = select.options[select.selectedIndex];
        const properties = {
          _fbt: 'true',
          _fbt_source_product: this.dataset.sourceProductId || '',
          _fbt_section: this.dataset.sectionId || ''
        };
        if (selected.dataset.preorder === 'true') properties['Pre-Order'] = 'Yes';
        return { id: Number(selected.value), quantity: 1, properties };
      });

      return this.addItemAndApplyDiscount(items, '');
    }

    updateTotal() {
      super.updateTotal();
      if (this.totalElement && this.totalElement.textContent && !this.totalElement.textContent.includes('USD')) {
        const shopify = window.Shopify;
        const currencyCode = (shopify && shopify.currency && shopify.currency.active) ? shopify.currency.active : 'USD';
        this.totalElement.textContent = `${this.formatMoney(this.total)} ${currencyCode}`;
      }
    }
  }

  customElements.define('fbt-component', FbtComponent);
}
